import { connect, MapDispatchToProps } from 'react-redux';
import { batchEditDisplayOptions } from '../../../actions/studio';
import { Props } from './DisplayOptionsBatchEdit';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchEditDisplayOptions'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  batchEditDisplayOptions: (displayResolution, addWatermark) =>
    dispatch(batchEditDisplayOptions(displayResolution, addWatermark)),
});

export default connect(null, mapDispatchToProps);
